import { render, staticRenderFns } from "./FormInformedConsent.vue?vue&type=template&id=897f1270&scoped=true"
import script from "./FormInformedConsent.vue?vue&type=script&lang=js"
export * from "./FormInformedConsent.vue?vue&type=script&lang=js"
import style0 from "./FormInformedConsent.vue?vue&type=style&index=0&id=897f1270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897f1270",
  null
  
)

export default component.exports